import type { Channel as ChannelModel } from '@/adapters/catalogv1.g';

export function extractChannel(model: ChannelModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.channel_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    archived: model.archived,
    private: model.private,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogChannel = ReturnType<typeof extractChannel>;
